import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "input"]
  static values = { url: String }

  connect() {
    this.dragCounter = 0
    this.handleDragEnter = this.handleDragEnter.bind(this)
    this.handleDragOver = this.handleDragOver.bind(this)
    this.handleDragLeave = this.handleDragLeave.bind(this)
    this.handleDrop = this.handleDrop.bind(this)

    this.element.addEventListener("dragenter", this.handleDragEnter)
    this.element.addEventListener("dragover", this.handleDragOver)
    this.element.addEventListener("dragleave", this.handleDragLeave)
    this.element.addEventListener("drop", this.handleDrop)
  }

  disconnect() {
    this.element.removeEventListener("dragenter", this.handleDragEnter)
    this.element.removeEventListener("dragover", this.handleDragOver)
    this.element.removeEventListener("dragleave", this.handleDragLeave)
    this.element.removeEventListener("drop", this.handleDrop)
  }

  handleDragEnter(event) {
    if (!this.hasFiles(event)) return
    event.preventDefault()
    this.dragCounter += 1
    this.showOverlay()
  }

  handleDragOver(event) {
    if (!this.hasFiles(event)) return
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  handleDragLeave(event) {
    if (!this.hasFiles(event)) return
    event.preventDefault()
    this.dragCounter -= 1
    if (this.dragCounter <= 0) {
      this.dragCounter = 0
      this.hideOverlay()
    }
  }

  handleDrop(event) {
    event.preventDefault()
    this.dragCounter = 0
    this.hideOverlay()

    const file = event.dataTransfer.files[0]
    if (file) this.uploadFile(file)
  }

  handlePick(event) {
    const file = event.target.files[0]
    if (file) this.uploadFile(file)
    event.target.value = ""
  }

  uploadFile(file) {
    const formData = new FormData()
    formData.append("file", file)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken,
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }

  hasFiles(event) {
    return event.dataTransfer && Array.from(event.dataTransfer.types || []).includes("Files")
  }

  showOverlay() {
    this.overlayTarget.classList.remove("hidden")
  }

  hideOverlay() {
    this.overlayTarget.classList.add("hidden")
  }
}
